<template>
    <section class="tables">
        <div class="row">
            <div class="col-lg-12 grid-margin stretch-card">
                <div class="card">
                    <div class="card-body">
                        <h2 class="card-title">{{ $t('names.carousel.name') }}</h2>
                        <p class="card-description">{{ $t('names.carousel.description') }}</p>
                        <b-button variant="primary" class="mt-4 mb-4" @click="$router.push('/carousel-item/new')">{{ $t('createNewTitle') }}</b-button>
                        <b-table striped hover :items="carouselItems" :fields="fields" @row-clicked="editCarouselItem" class="clickable"></b-table>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import axios from 'axios'
    import {Const} from '../../../config'

    export default {
        name: 'CarouselItemList',
        data() {
            return {
              carouselItems: [],
                fields: [
                    {
                        key: 'id',
                        label: 'ID',
                        sortable: true,
                        thStyle: 'width: 75px;'
                    },
                    {
                        key: 'name',
                        label: this.$t('forms.name'),
                        sortable: true
                    }
                ]
            }
        },
        mounted() {
            axios.get(Const.API_HOST + '/admin/carouselItems')
                .then(response => response.data).then(body => {
                this.carouselItems = body
            }).catch(error => {
                // eslint-disable-next-line no-console
                console.error(error)
            })
        },
        methods: {
            editCarouselItem(item) {
                this.$router.push('/carousel-item/edit/' + item.id)
            }
        }
    }
</script>

<style scoped>
    .clickable /deep/ tbody td {
        cursor: pointer;
    }

</style>
